<template>
  <div class="appBodyHolder" :style="{ 'background-color': backgroundColor }">
    <div class="development" v-if="development && !local">
      <div class="mode">
        <i class="fa fa-unlock" aria-hidden="true"></i> This site is in -
        <span>Development Mode</span>
      </div>
    </div>
    <div class="ssl" v-if="!ssl && !development">
      <i class="fa fa-unlock" aria-hidden="true"></i> <span>Warning:</span> This
      site has been loaded without encryption. Please use caution as your data
      is not encrypted.
    </div>
    <router-view name="header"></router-view>
    <main style="height: 100%">
      <fade-transition origin="center" mode="out-in" :duration="250">
        <router-view />
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
    <base-message></base-message>
  </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";
import { getDomainInfo } from "./services/auth";
export default {
  components: {
    FadeTransition,
  },
  data() {
    return {
      development: false,
      ssl: true,
      local: false,
      backgroundColor: this.$theme.background,
    };
  },
  async created() {
    this.checkDomain();
    window.addEventListener("theme", () => {
      this.backgroundColor = this.$theme.background;
    });
  },
  methods: {
    async checkDomain() {
      this.local = process.env.NODE_ENV == "production" ? false : true;
      let res = await getDomainInfo();
      if (res && res.status === 200) {
        this.development = res.result.development;
        this.ssl = res.result.SSL.valid;
      }
    },
  },
};
</script>
<style lang="scss">
.appBodyHolder {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.development {
  z-index: 900;
  padding: 1rem;
  color: #fb6340;
  text-align: center;
  span {
    font-weight: bold;
  }
}
.ssl {
  text-align: center;
  padding: 1rem 0;
  background: #fb6340;
  color: white;
  span {
    font-weight: bold;
  }
}
</style>
